import { Injectable, ElementRef, ViewChild, Inject } from "@angular/core";
import {
  MatSnackBar,
} from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class SnackService {

  class: string;

  @ViewChild('primary') primaryElement: ElementRef;
  @ViewChild('accent') accentElement: ElementRef;
  @ViewChild('warn') warnElement: ElementRef;

  constructor(
    private _snackBar: MatSnackBar) {
  }

  openSnackBar(type: string, msg: string) {

    type = type.trim().toLowerCase();

    switch (type) {

      case "primary": {
        this.class = "snackbar_primary";
        break;
      }
      case "secondary": {
        this.class = "snackbar_secondary";
        break;
      }
      case "info": {
        this.class = "snackbar_info";
        break;
      }
      case "warning": {
        this.class = "snackbar_warning";
        break;
      }
      case "success": {
        this.class = "snackbar_green";
        break;
      }
      case "danger": {
        this.class = "snackbar_red";
        break;
      }
      default: {
        this.class = "";
        break;
      }
    }

    this._snackBar.open(msg, "", {
      duration: 2500,
      panelClass: this.class,
      horizontalPosition: "right",
      verticalPosition: "top"
    });
  }


}



@Injectable({
  providedIn: "root",
})
export class BmiCalculationService {


  constructor() {
  }

  calculate(height: any, heightUnit: string, weight: any, weightUnit: string) {

    var bmi_value: any = 0;
    var weightVar = 0;
    var heightVar = 0;

    if (weightUnit == 'Lbs') {
      weightVar = weight * 0.45359237;
    } else {
      weightVar = weight;
    }

    //Feet to cm
    if (heightUnit == 'Feet') {

      heightVar = height * 30.48;

    } else {
      heightVar = height;
    }



    if (weightVar > 0 && heightVar > 0) {
      bmi_value = ((weightVar) / heightVar / heightVar * 10000);


      // bmi_value = ((weightVar/2.205) / ((heightVar/39.37) * (heightVar/39.37)));
    }

    return parseFloat(bmi_value).toFixed(2);



  }


}



@Injectable({
  providedIn: "root",
})
export class JsonGroupByService {


  constructor() {
  }

  jsongroupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };


}
